export const inputItems: Array<{
	name: "marketplace" | "companyId" | "startDate" | "endDate" | "search" | "categoryId";
	type: "text" | "date";
	placeholder: string;
	showType: "input" | "select" | "date" | "multiselect";
}> = [
	{
		name: "search",
		type: "text",
		placeholder: "Search",
		showType: "input",
	},
	{
		name: "marketplace",
		type: "text",
		placeholder: "Marketplace",
		showType: "select",
	},
	{
		name: "companyId",
		type: "text",
		placeholder: "Company",
		showType: "select",
	},
	{
		name: "categoryId",
		type: "text",
		placeholder: "Category",
		showType: "multiselect"
	},
	{
		name: "startDate",
		type: "date",
		placeholder: "Start Date",
		showType: "date",
	},
	{
		name: "endDate",
		type: "date",
		placeholder: "End Date",
		showType: "date",
	},
];
